import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox, withStyles } from 'material-ui';
import CheckboxStyles from './CheckboxStyles';

const StandardCheckbox = ({ label, value, name, onChange, classes }) => (
  <FormControlLabel
    className={classes.root}
    control={
      <Checkbox
        checked={value}
        onChange={onChange(name)}
        classes={{ checked: classes.checked }}
        value={name}
      />
    }
    label={label}
  />
);

StandardCheckbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.number, PropTypes.bool ]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(CheckboxStyles)(StandardCheckbox);



// WEBPACK FOOTER //
// ./src/components/checkbox/Checkbox.js